import React from 'react'
import { SelectionPhaseContainer } from '@/components/containers/selection-phase'
import { useTitle } from '@/hooks/use-title'
import SettingsIcon from '@material-ui/icons/Settings'

export const SelectionPhasePage: React.FC = (props) => {
  useTitle('設定 / 選考フェーズ', <SettingsIcon />)
  return <SelectionPhaseContainer {...props} />
}
